import { config } from '../config';

const shopName = config.shop.split('.')[0];

const AMAZON_BASE_URL = process.env.REACT_APP_AMAZON_URL;
export const LINK = {
  ORDER_CONFIRMATION_ADMIN: `https://admin.shopify.com/store/${shopName}/email_templates/order_confirmation/edit`,
};
export const THUMBNAIL = {
  ORDER_CONFIRMATION_IMG: `${AMAZON_BASE_URL}assets/date-time-confirmation-email.webp`,
  ONBOARDING_IMG: `https://storage.synctrack.io/megamind-dingdoong/assets/onboarding-1.png`,
  ONBOARDING_THEME_IMG: `https://storage.synctrack.io/megamind-dingdoong/assets/onboarding-2.png`,
  ONBOARDING_FINISH_IMG: `https://storage.synctrack.io/megamind-dingdoong/assets/facetime-meeting-2.png`,
  DASHBOARD_CTA_IMG: `https://storage.synctrack.io/megamind-dingdoong/assets/facetime-meeting.png`,
  WIDGET_APPEARANCE_CTA_IMG: `https://storage.synctrack.io/megamind-dingdoong/assets/facetime-meeting-2.png`,
  EMPTY_STATE_TRANSLATION_IMG: `https://storage.synctrack.io/megamind-dingdoong/assets/empty-state-translation.svg`,
  EMPTY_METHOD_IMG: `https://storage.synctrack.io/megamind-dingdoong/assets/empty-method.png`,
};

export const IMAGE = {
  DEMO_CART_PAGE_IMG: `https://storage.synctrack.io/megamind-dingdoong/assets/demo-cart-page-display.png`,
  DEMO_PRODUCT_PAGE_IMG: `https://storage.synctrack.io/megamind-dingdoong/assets/demo-product-page-display.png`,
  VERIFIED_EMAIL_IMG: `https://storage.synctrack.io/megamind-dingdoong/assets/verified_email.png`,
};
